import { Auth } from 'aws-amplify';
import { SignIn } from 'aws-amplify-react';

import { Button, CircularProgress } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';

class Login extends SignIn {
  constructor(props) {
    super(props);

    this.state = {
      username: '',
      password: '',
      loading: false,
    };
  }

  handleChange = (e) => {
    this.setState({
      [e.target.id]: e.target.value,
    });
    e.preventDefault();
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.signIn(this.state);
  };

  signIn = async function ({ username, password }) {
    this.setState({ loading: true });
    try {
      await Auth.signIn(username, password);
      window.location.reload();
    } catch (error) {
      console.log('error signing in', error);
    }
    this.setState({ loading: false });
  };

  render() {

    const { classes } = this.props;
    const isLoading = this.state.loading;

    return (
      <form className={classes.loginForm} onSubmit={this.handleSubmit}>
        <AccountCircleIcon className={classes.loginIcon} />
        <input type="email" className={classes.loginInput} onChange={(e) => this.setState({ username: e.target.value })} value={this.state.username} autoFocus required placeholder="Email" />
        <input type="password" className={classes.loginInput} onChange={(e) => this.setState({ password: e.target.value })} value={this.state.password} required placeholder="Password" />
        {isLoading ? <CircularProgress
          variant="indeterminate"
          disableShrink
          className={classes.top}
          size={40}
          thickness={4}
        />
          : <Button type="submit" variant="outlined" size='large' classes={{
            root: classes.buttonRoot
          }}> Login </Button>
        }

      </form>
    );
  }
}

const styles = (theme) => ({
  loginForm: {
    display: 'flex',
    background: '#142966',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100VH',
    overflow: 'hidden',
    margin: 'auto'
  },
  loginIcon: {
    fontSize: '120px',
    color: 'white'
  },
  loginInput: {
    "&::placeholder": {
      color: "gray"
    },
    background: 'transparent',
    border: '2px solid rgba(255, 255, 255, 0.6)',
    borderRadius: '5px',
    color: 'white',
    display: 'block',
    margin: '1rem',
    padding: '0.5rem',
    transition: '250ms background ease-in',
    maxWidth: '280px',
    width: 'calc(100% - 3rem)'
  },
  buttonRoot: {
    color: 'gray',
    borderColor: 'gray',
    marginTop: '24px',
    transition: '250ms background ease-in'
  },
  top: {
    marginTop: '24px',
    color: 'white',
    animationDuration: '900ms'
  }
});

export default withStyles(styles)(Login);
